/**
 * Helpers shared by the client-rendered chart steps (Bar & Column, Line &
 * Area) and the shell.
 */

/**
 * True when a tile's widget data came back from the compute API in a shape
 * the form no longer describes: the saved capabilities' category exists in
 * the server rows but the form's current category does not — i.e. the tile
 * must keep rendering its server rows instead of the raw dataset rows.
 */
export function isServerComputedClientTile(data: Record<string, unknown> | null | undefined, formCategory: string): boolean {
  const rows = data?.['staticData'] as Array<Record<string, unknown>> | undefined;
  const caps = data?.['capabilities'] as Record<string, unknown> | undefined;
  const first = Array.isArray(rows) ? rows[0] : undefined;
  if (!first || !caps) return false;
  const capCategory = String(caps['category'] ?? '');
  return !!capCategory && capCategory in first && !!formCategory && !(formCategory in first);
}
